import { Box, Typography, makeStyles } from "@material-ui/core";

import React from "react";
import { de } from "date-fns/locale";
import logo from "../../../assets/icons/logologin.png";
import moment from "moment";
import settings from "../../../utils/settings";
import useOneBranch from "../../../hooks/useOneBranch";
import useOneUser from "../../../hooks/useOneUser";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => {
  return {
    hidden: {
      display: "none",
    },
    container: {
      borderRadius: 0,
      paddingTop: 17,
      margin: "0 auto",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
    },
    topSection: {
      display: "grid",
      paddingLeft: 24,
      paddingRight: 24,
      gridTemplateColumns: "193px 193px",
      marginTop: 20,
    },
    receiptTitle: {
      marginTop: 22,
    },
    makeBold: {
      fontWeight: "bolder",
    },
    normalFont: {
      fontSize: 14,
      color: theme.black,
      lineHeight: "18px",
      wordWrap: "break-word",
    },

    smallFont: {
      fontSize: 8,
      color: theme.black,
      lineHeight: "12px",
    },

    boldFont: {
      fontSize: 18,
      fontWeight: "bold",
      color: theme.black,
      lineHeight: "20px",
    },
    onLeft: {
      justifySelf: "start",
    },
    onRight: {
      justifySelf: "end",
    },
    onCenter: {
      justifySelf: "center",
    },
    productTitleSection: {
      display: "flex",
      paddingLeft: 24,
      paddingRight: 24,
      flexDirection: "row",
      width: "500px",
      boxSizing: "border-box",
      alignItems: "center",
    },
    productSection: {
      display: "grid",
      paddingLeft: 24,
      paddingRight: 24,
      gridTemplateColumns: "35px 224px 98px",
      gridAutoRows: "29px",
      gap: "15px",
      boxSizing: "border-box",
      alignItems: "center",
    },
    bottomSection: {
      display: "grid",
      paddingLeft: 24,
      paddingRight: 24,
      gridTemplateColumns: "134px 20px 146px",
      gridAutoRows: "29px",
      alignItems: "center",
    },
    lastTotalFont: {
      fontSize: 18,
      lineHeight: "22px",
      fontWeight: "bolder",
      color: theme.black,
    },
    bottomSecondSection: {
      display: "grid",
      paddingLeft: 24,
      paddingRight: 24,
      gridTemplateColumns: "70% 30%",
      gridAutoRows: "20px",
      width: "387px",
      alignItems: "center",
    },
    pointtobeEarn: {
      display: "flex",
      flexDirection: "row",
    },
  };
});

/**
 * PARAMS
 * isCI : mean open from CI, some data will be changed (staffName,branch, tier_name , current Point display)
 * receipt: {id, date, paymentResult: {remainingPoint: 100}}for id and date and receipt?.paymentResult?.remainingPoint
 * payment: {paymentChannels: [{type: "", amount: 10}], member: {firstname: "",lastname: ""} for paymentChannel and member information
 * paymentTransaction : {staff: {firstname, lastname} , items: [...], tier_name: "", summary: {total_qty, total_payment, total_revenue, earn_amount}}
 * @returns
 */
const Receipt = React.forwardRef(
  ({ receipt, payment, paymentTransaction, isCI }, ref) => {
    const { id } = settings();
    let { /* merchantName,*/ branchId } = settings();
    let staffId = id;
    if (isCI) {
      branchId = paymentTransaction.branchId;
      staffId = paymentTransaction.staffId;
    }

    const { branch, loading } = useOneBranch(branchId);

    const receiptId = receipt.id;
    const time = moment(receipt.date).format("HH:mm");

    const date = moment(receipt.date).format("DD MMM YY");
    //  const items = paymentTransaction.items; //receipt.itemList;
    const products = paymentTransaction.items
      .filter((i) => i.item_type === "product")
      .map((item) => ({
        name: item.product_name,
        code: item.code,
        qty: item.qty,
        price: item.charge_amount,
      }));
    const tierPrivilege = paymentTransaction.items.filter(
      (i) => i.item_type === "privilege"
    );

    const discounts = paymentTransaction.items.filter(
      (i) =>
        i.item_type === "offer" &&
        i.coupons[0].type === "discount" &&
        !i.coupons[0].discount_percent
    );

    const discountsPercent = paymentTransaction.items.filter(
      (i) =>
        i.item_type === "offer" &&
        i.coupons[0].type === "discount" &&
        i.coupons[0].discount_percent
    );

    const specialOfferMultiply = paymentTransaction.items.filter(
      (i) => i.item_type === "offer" && i.coupons[0].type === "multiplier"
    );

    const specialOfferPlus = paymentTransaction.items.filter(
      (i) => i.item_type === "offer" && i.coupons[0].type === "reward"
    );

    const redeems = paymentTransaction.items.filter(
      (i) => i.item_type === "discount"
    );

    const totalQTY = paymentTransaction?.summary?.total_qty;
    const totalPrice = paymentTransaction?.summary?.total_payment;

    const totalwithDiscount = paymentTransaction?.summary?.total_revenue;
    const pointtoEarn = paymentTransaction?.summary?.earn_amount;
    if (loading) return null;
    const address = branch.address;

    //const totalwithDiscountbeforeVat = receipt.totalPriceafterDiscount - vatValue;
    return (
      <Box ref={ref} id="saveme" style={{ backgroundColor: "white" }}>
        <ReceiptComponent
          isCI={isCI}
          totalQTY={totalQTY}
          totalPrice={totalPrice}
          totalwithDiscount={totalwithDiscount}
          pointtoEarn={pointtoEarn}
          address={address}
          products={products}
          date={date}
          time={time}
          receiptId={receiptId}
          tierPrivilege={tierPrivilege}
          discounts={discounts}
          specialOfferMultiply={specialOfferMultiply}
          specialOfferPlus={specialOfferPlus}
          redeems={redeems}
          payment={payment}
          receipt={receipt}
          branchId={branchId}
          staffId={staffId}
          paymentTransaction={paymentTransaction}
          discountsPercent={discountsPercent}
        />
      </Box>
    );
  }
);

const ReceiptComponent = ({
  branchId,
  receiptId,
  date,
  time,
  address,
  staffId,
  products,
  tierPrivilege,
  discounts,
  totalwithDiscount,
  totalQTY,
  totalPrice,
  paymentTransaction,
  discountsPercent,
  specialOfferMultiply,
  specialOfferPlus,
  redeems,
  payment,
  pointtoEarn,
  receipt,
  isCI,
}) => {
  const classes = useStyles();
  const translate = useTranslate();
  const { taxId, showVat, merchantName } = settings();
  const { branch, loading } = useOneBranch(branchId);
  const { user, loading: userLoading } = useOneUser(staffId);

  const deliveryCost = Number(
    paymentTransaction.deliveryCost ?? paymentTransaction.delivery_cost ?? 0
  );
  if (loading || !branch || userLoading || !user)
    return <Typography>Loading</Typography>;
  return (
    <Box className={classes.container}>
      <Box>
        {/* <img
          alt="logo"
          src={branch?.image_url ? branch?.image_url : logo}
          style={{
            width: "100%",
            height: 50,
            margin: "0 auto",
            borderWidth: 2,
            color: "black",
            objectFit: "contain",
          }}
        /> */}
        <Typography variant="h5" align="center">
          {process.env.REACT_APP_RECEIPT_MERCHANT_NAME ?? merchantName}
        </Typography>
      </Box>

      <Box className={classes.topSection}>
        {showVat ? (
          <>
            <Typography className={[classes.normalFont]}>
              {branch.name}
            </Typography>
            <Typography className={[classes.onRight, classes.normalFont]}>
              {`No.${receiptId}`}
            </Typography>
            <Typography className={[classes.normalFont]}>
              Tax #{taxId} (Vat Included)
            </Typography>
            <Typography className={[classes.onRight, classes.normalFont]}>
              Time: {time}
            </Typography>
            <Typography className={[classes.normalFont]}>{address}</Typography>
            <Typography className={[classes.normalFont, classes.onRight]}>
              Date: {date}
            </Typography>
            <Typography className={[classes.normalFont]}>
              Staff name:{` ${user.firstname} ${user.lastname}`}
            </Typography>
          </>
        ) : (
          <>
            <Typography className={[classes.normalFont]}>
              {branch.name}
            </Typography>
            <Typography className={[classes.onRight, classes.normalFont]}>
              {`No.${receiptId}`}
            </Typography>
            <Typography className={[classes.normalFont]}>{address}</Typography>
            <Typography className={[classes.onRight, classes.normalFont]}>
              Time: {time}
            </Typography>
            <Typography className={[classes.normalFont]}>
              Staff name:{` ${user.firstname} ${user.lastname}`}
            </Typography>
            <Typography className={[classes.onRight, classes.normalFont]}>
              Date: {date}
            </Typography>
          </>
        )}
      </Box>
      <Typography
        className={[classes.onCenter, classes.boldFont, classes.receiptTitle]}
      >
        {translate("ra.text.receiptTitle")}
      </Typography>
      <CustomDivider />
      <Box className={classes.productSection}>
        <Typography className={[classes.onLeft, classes.normalFont]}>
          {`${translate("ra.text.qty")} . `}
        </Typography>
        <Typography className={[classes.normalFont]}>
          {translate("ra.text.addProduct.productName")}
        </Typography>
        <Typography boldFont className={[classes.onRight, classes.normalFont]}>
          {`THB . `}
        </Typography>
      </Box>
      <CustomDivider />
      <Box className={classes.productSection}>
        {products.map((item) => (
          <>
            <Typography className={[classes.onCenter, classes.normalFont]}>
              {item.qty}
            </Typography>
            <Box>
              <Typography className={classes.normalFont} noWrap>
                {item.name}
              </Typography>
              <Typography className={classes.smallFont} noWrap>
                {/*item.code*/}
              </Typography>
            </Box>

            <Typography className={[classes.onRight, classes.normalFont]}>
              {Number(item.price).toLocaleString()}
            </Typography>
          </>
        ))}
      </Box>
      <CustomDivider />

      <Box className={classes.bottomSecondSection}>
        <Typography className={[classes.normalFont]}>
          {translate("ra.text.receipt.subtotal")} {totalQTY} item(s)
        </Typography>
        <Typography className={[classes.onRight, classes.normalFont]}>
          {Number(totalPrice).toLocaleString()}
        </Typography>
        <Typography className={[classes.normalFont]}>
          {translate("ra.text.delivery_cost")}
        </Typography>
        <Typography className={[classes.onRight, classes.normalFont]}>
          {Number(deliveryCost).toLocaleString()}
        </Typography>
        {tierPrivilege.map((tier) => {
          return tier.coupons.map((coupon) => {
            if (coupon.type) {
              return (
                <>
                  <Typography
                    className={[classes.normalFont]}
                    noWrap
                  >{`${paymentTransaction.tier_name} ${coupon.desc}`}</Typography>
                  <Typography className={[classes.onRight, classes.normalFont]}>
                    {`${coupon.descValue.replace("THB", "")}`}
                  </Typography>
                </>
              );
            } else return null;
          });
        })}
        {discounts.map((discount) => {
          return (
            <>
              <Typography
                className={[classes.normalFont]}
                noWrap
              >{`${discount.coupons[0].shortDesc}`}</Typography>
              <Typography className={[classes.onRight, classes.normalFont]}>
                {`${Number(
                  discount.coupons[0].discount_amount
                ).toLocaleString()}`}
              </Typography>
            </>
          );
        })}
        {discountsPercent.map((discount) => {
          return (
            <>
              <Typography
                className={[classes.normalFont]}
                noWrap
              >{`${discount.coupons[0].shortDesc}`}</Typography>
              <Typography className={[classes.onRight, classes.normalFont]}>
                {`${Number(
                  discount.coupons[0].discount_amount
                ).toLocaleString()}`}
              </Typography>
            </>
          );
        })}
        {specialOfferMultiply.map((offer) => {
          return (
            <>
              <Typography className={[classes.normalFont]} noWrap>{`${translate(
                "ra.text.specialOffers"
              )} ${offer.coupons[0].shortDesc}`}</Typography>
              <Typography
                className={[classes.onRight, classes.normalFont]}
              ></Typography>
            </>
          );
        })}
        {specialOfferPlus.map((offer) => {
          return (
            <>
              <Typography noWrap className={[classes.normalFont]}>{`${translate(
                "ra.text.specialOffers"
              )} ${offer.coupons[0].shortDesc}`}</Typography>
              <Typography
                className={[classes.onRight, classes.normalFont]}
              ></Typography>
            </>
          );
        })}
        {redeems.map((redeem) => {
          return (
            <>
              <Typography noWrap className={[classes.normalFont]}>
                {`${translate("ra.text.pointasCash")} ${Math.abs(
                  redeem.redeem?.amount
                )} ${translate("ra.text.points")}`}
              </Typography>
              <Typography className={[classes.onRight, classes.normalFont]}>
                {`${Number(redeem.discount_amount).toLocaleString()}`}
              </Typography>
            </>
          );
        })}
        {showVat ? (
          <>
            <Typography className={[classes.normalFont]}>
              Vat {process.env.REACT_APP_VAT} %
            </Typography>
            <Typography className={[classes.normalFont, classes.onRight]}>
              {(
                (Number(totalwithDiscount + deliveryCost) * 7) /
                100
              ).toLocaleString()}
            </Typography>
            <Typography className={[classes.normalFont]}>
              {" "}
              {translate("ra.text.receipt.total")}
            </Typography>
            <Typography className={[classes.normalFont, classes.onRight]}>
              {Number(totalwithDiscount + deliveryCost).toLocaleString()}
            </Typography>
            <Typography className={[classes.normalFont]}>Before VAT</Typography>
            <Typography className={[classes.normalFont, classes.onRight]}>
              {(
                Number(totalwithDiscount + deliveryCost) -
                (Number(totalwithDiscount + deliveryCost) * 7) / 100
              ).toLocaleString()}
            </Typography>{" "}
          </>
        ) : (
          <></>
        )}
      </Box>
      <CustomDivider />
      <Box className={classes.bottomSecondSection}>
        <Typography className={[classes.lastTotalFont]}>
          {translate("ra.text.receipt.total")}
        </Typography>
        <Typography className={[classes.lastTotalFont, classes.onRight]}>
          {Number(totalwithDiscount + deliveryCost).toLocaleString()}
        </Typography>
      </Box>
      <CustomDivider />
      <Box className={classes.bottomSecondSection}>
        {payment.paymentChannels.map((pay) => {
          return (
            <>
              <Typography className={[classes.normalFont]}>
                {translate("ra.text.purchasedBy")} {pay.type}
              </Typography>
              <Typography className={[classes.normalFont, classes.onRight]}>
                {Number(pay.amount + deliveryCost).toLocaleString()}
              </Typography>
            </>
          );
        })}
        <Box className={classes.pointtobeEarn}>
          <Typography className={[classes.normalFont]}>
            {`${translate("ra.text.addProduct.pointtobeEarned")}`}
          </Typography>
          <Typography
            className={[classes.makeBold, classes.normalFont]}
            style={{ marginLeft: "4px" }}
          >
            {`${pointtoEarn} ${translate("ra.text.points")}`}
          </Typography>
        </Box>
        <Box></Box>
      </Box>
      <CustomDivider />
      <Box className={classes.bottomSecondSection}>
        <Typography className={[classes.normalFont]}>
          {translate("ra.text.bi.customer")}:{" "}
          {payment.member?.firstname ?? translate("ra.text.bi.walkIn")}{" "}
          {payment.member?.lastname ?? ""}
        </Typography>
        <Box></Box>
        <Typography className={[classes.normalFont]}>
          {isCI
            ? ""
            : `${translate("ra.text.receipt.remainingPoint")}: 
          ${receipt?.paymentResult?.remainingPoint ?? 0} ${translate(
                "ra.text.points"
              )}`}
        </Typography>
        <Box></Box>
      </Box>
      <CustomDivider />
      <Box>
        <Typography>
          {process.env.REACT_APP_RECEIPT_FOOTER ?? "Thank you"}
        </Typography>
        <Box style={{ height: 20 }}></Box>
      </Box>
    </Box>
  );
};

const CustomDivider = () => {
  return (
    <Box
      style={{
        height: 1,
        width: "387px",
        borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
        marginTop: 15,
        marginBottom: 15,
      }}
    ></Box>
  );
};
export default Receipt;
